<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Captura de Beneficiarios" />
      <CaptureBeneficiaries/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import CaptureBeneficiaries from '@/components/Beneficiarie/CaptureBeneficiaries.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {

    }
  },
  name: 'CaptureBeneficiarieView',
  components: {
    Header,
    CaptureBeneficiaries,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>